import { message, Spin, Upload} from 'antd';
import ImageUrl from '../../../helpers/ImageUrl';
import { PictureOutlined } from '@ant-design/icons';
import React, { useState, useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { UPLOAD } from '../../../graphql/upload';

export default function CustomUpload (props) {
    const [uploadFileMutation, { loading }] = useMutation(UPLOAD);
    const [data, setData] = useState(props.value);

    useEffect(() => {
        props.onChange(data)
    }, [data, props.onChange])

    return (
        <Upload.Dragger
            {...props}
            fileList={null}
            customRequest={async ({ file, onError, onSuccess }) => {
                try {
                    const res = await uploadFileMutation({ variables: { file: file } });
                    setData({
                        id: res.data.upload.data.id,
                        url: res.data.upload.data.attributes.url,
                    });
                    onSuccess();
                } catch (error) {
                    message.error(error.message);
                    console.error(error);
                    onError();
                    return false;
                }
            }}
            className={'upload-file'}
        >
            {loading ? (
                <Spin spinning />
            ) : data ? (
                <img width={props.imgWidth || 264} height={props.imgHeight || 264} style={{objectFit: props.imgFit || 'cover'}} src={ImageUrl(data.url)} alt={'logo'} />
            ) : (
                <>
                    <h2>
                        <PictureOutlined />
                    </h2>
                    <div>Нажмите или переместите файл сюда</div>
                    <div className={'caption'}>Только один файл изображения</div>
                    <div className={'caption'}>Рекомендуем SVG или PNG, 300x120px</div>
                </>
            )}
        </Upload.Dragger>
    );
}